import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CaseWidgetComponent } from './components/case-widget/case-widget.component';
import { SharedModule } from '@app/shared/shared.module';
import { AgGridModule } from 'ag-grid-angular';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { CaseWidgetSettingsDialogComponent } from './components/case-widget-settings-dialog/case-widget-settings-dialog.component';
import { InboxActionCellRendererComponent } from './components/case-widget/inbox-action-cell-renderer.component';


@NgModule({
  declarations: [
    DashboardComponent,
    CaseWidgetComponent,
    CaseWidgetSettingsDialogComponent,
    InboxActionCellRendererComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    AgGridModule.withComponents([CaseWidgetComponent, InboxActionCellRendererComponent])
  ]
})
export class DashboardModule { }
